import * as React from 'react';
import { Label } from './label';
import { cn } from '@/lib/cn';

export interface FieldProps {
  label: string;
  htmlFor?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  className?: string;
  children: React.ReactNode;
}

/**
 * Form field wrapper — label + optional hint + the control + error message.
 * Tight vertical rhythm; designed to stack densely in section grids.
 */
export function Field({ label, htmlFor, hint, error, required, className, children }: FieldProps) {
  return (
    <div className={cn('space-y-1.5', className)}>
      <div className="flex items-baseline justify-between gap-3">
        <Label htmlFor={htmlFor}>
          {label}
          {required ? <span className="ml-1 text-error" aria-hidden="true">*</span> : null}
        </Label>
        {hint ? <span className="text-xs text-text-subtle">{hint}</span> : null}
      </div>
      {children}
      {error ? <p className="text-xs text-error">{error}</p> : null}
    </div>
  );
}
